import React from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { BackButton, IconLink, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

// ────────────────────────────────────────────────────────────────────────────────

export const NavbarBackButton = (props: ProductDetailsBackButtonProps) => {
  const { containerStyle, variation = 'arrow', onPress } = props;
  const { t } = useLocalizationContext();
  const label = t('general.menu');

  if (variation === 'close') {
    return (
      <IconLink
        name="IconClose"
        onPress={onPress}
        accessibilityLabel={t('general.close')}
        accessibilityHint={t('general.close')}
      />
    );
  }

  return (
    <View style={styles.wrapper}>
      <BackButton
        containerStyle={containerStyle}
        label={label}
        onPress={onPress}
        uppercase
      />
    </View>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flexShrink: 1,
    paddingLeft: theme.spacing['10'],
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ProductDetailsBackButtonProps = {
  readonly containerStyle?: ViewStyle;
  readonly variation?: 'arrow' | 'close';
  readonly onPress: () => void;
};
